'use strict';



import commonNavigation from './common-navigation';
import commonScrollNavigation from './common-scroll-navigation';

export default function (API) {

	commonNavigation.init();
	commonScrollNavigation();
	API.log('INIT Navigation');

}
